import { useMutation, useQueryClient } from "@tanstack/react-query";
import { apiClient } from '../api-manager-instance';
import { ENDPOINTS } from '../endpoints';
import { toast } from "react-toastify";

export const useRemoveOrderFromBatch = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: async ({ batchId, serviceId }: { batchId: string; serviceId: string }) => {
            const res = await apiClient.patch(ENDPOINTS.BATCHES.REMOVE_ORDER(batchId), { serviceId });
            return res.data;
        },
        onSuccess: (data, { batchId }) => {
            toast.success(data?.message || "Order removed from batch successfully!");
            queryClient.invalidateQueries({ queryKey: ["get_batch_by_id", batchId] });
            queryClient.invalidateQueries({ queryKey: ["get_all_batches"] });
        },
        onError: (err: any) => {
            toast.error(err?.response?.data?.message || err?.message || "Failed to remove order from batch");
        },
    });
};
